import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ErrorCodes from "../../constants/ErrorCodes";
import { useSelectFunctions } from "../../functions";

const WinPlaceShow = ({
  entries,
  charts,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idWin,
  displayInfoChart,
  raceID,
  setSessionNoLongerExists,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectionsSelected,
  getCharts,
}) => {
  const [showBetsColumn, setShowBetsColumn] = useState(false);
  const { getOpenBetsByWT } = useSelectFunctions();
  let headers, moneyBetHeaders;

  //Function to load Open Bets info by Entry for each betType (Modal)
  const getOpenBetsChartByWT = async (ticketType) => {
    const res = await getOpenBetsByWT(
      {
        RaceID: raceID,
        WagerType: ticketType,
      },
      userInfo.LogonSessionID
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setOpenBetsChartInfo(res.RaceTicketMainList);
    }
  };

  let chkColumBets = document.getElementById("switchColumnBetsEvent");
  if (chkColumBets && !showBetsColumn) {
    chkColumBets.checked = false;
  }

  charts.forEach((chart, j) => {
    entries.forEach((entry, i) => {
      if (parseInt(chart.Selections) === entry.EntryNum) {
        if (chart.BetType === 0) {
          entry.Win = { Amount: chart.Amount, BetCount: chart.BetCount };
        }
        if (chart.BetType === 1) {
          entry.Place = { Amount: chart.Amount, BetCount: chart.BetCount };
        }
        if (chart.BetType === 2) {
          entry.Show = { Amount: chart.Amount, BetCount: chart.BetCount };
        }
      }
    });
  });

  var tableContent = [];

  entries &&
    entries.forEach((item, i) => {
      let classDel = "";
      if (item.FinishPos === -1) {
        classDel = "scratchPool";
      } else {
        classDel = "";
      }
      tableContent.push(
        <tr key={i}>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            <EntryColor
              entryNum={item.EntryNum}
              saddleNum={item.SaddleNum}
              finishPos={item.FinishPos}
            />
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
            className={classDel}
          >
            {item.EntryName}
          </td>
          {/* WIN */}
          {showBetsColumn ? (
            <>
              <td
                style={{
                  verticalAlign: "middle",
                }}
              >
                {item.Win && item.Win.Amount !== 0 ? (
                  <span style={{ fontWeight: "bold" }}>
                    ${item.Win.Amount.toFixed(2)}
                  </span>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
              <td
                style={{ verticalAlign: "middle" }}
                className="cantBets"
                data-toggle="modal"
                data-target="#openBetsChartModal"
                onClick={() => {
                  getOpenBetsChartModal(idWin, item.EntryNum);
                  setSelectionsSelected(item.EntryNum);
                }}
              >
                {item.Win && item.Win.BetCount !== 0 ? (
                  <span>{item.Win.BetCount}</span>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
            </>
          ) : (
            <td
              style={{
                verticalAlign: "middle",
              }}
            >
              {item.Win && item.Win.Amount !== 0 ? (
                <span style={{ fontWeight: "bold" }}>
                  ${item.Win.Amount.toFixed(2)}
                </span>
              ) : (
                item.FinishPos === -1 && <span>-</span>
              )}
            </td>
          )}
          {/* PLACE */}
          {showBetsColumn ? (
            <>
              <td
                style={{
                  verticalAlign: "middle",
                }}
              >
                {item.Place && item.Place.Amount !== 0 ? (
                  <>
                    <span style={{ fontWeight: "bold" }}>
                      ${item.Place.Amount.toFixed(2)}
                    </span>
                  </>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
              <td
                style={{ verticalAlign: "middle" }}
                className="cantBets"
                data-toggle="modal"
                data-target="#openBetsChartModal"
                onClick={() => {
                  getOpenBetsChartModal(1, item.EntryNum);
                  setSelectionsSelected(item.EntryNum);
                }}
              >
                {item.Place && item.Place.BetCount !== 0 ? (
                  <span>{item.Place.BetCount}</span>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
            </>
          ) : (
            <td
              style={{
                verticalAlign: "middle",
              }}
            >
              {item.Place && item.Place.Amount !== 0 ? (
                <>
                  <span style={{ fontWeight: "bold" }}>
                    ${item.Place.Amount.toFixed(2)}
                  </span>
                </>
              ) : (
                item.FinishPos === -1 && <span>-</span>
              )}
            </td>
          )}

          {/* SHOW */}
          {showBetsColumn ? (
            <>
              <td
                style={{
                  verticalAlign: "middle",
                }}
              >
                {item.Show && item.Show.Amount !== 0 ? (
                  <span style={{ fontWeight: "bold" }}>
                    ${item.Show.Amount.toFixed(2)}
                  </span>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
              <td
                style={{ verticalAlign: "middle" }}
                className="cantBets"
                data-toggle="modal"
                data-target="#openBetsChartModal"
                onClick={() => {
                  getOpenBetsChartModal(2, item.EntryNum);
                  setSelectionsSelected(item.EntryNum);
                }}
              >
                {item.Show && item.Show.BetCount !== 0 ? (
                  <span>{item.Show.BetCount}</span>
                ) : (
                  item.FinishPos === -1 && <span>-</span>
                )}
              </td>
            </>
          ) : (
            <td
              style={{
                verticalAlign: "middle",
              }}
            >
              {item.Show && item.Show.Amount !== 0 ? (
                <span style={{ fontWeight: "bold" }}>
                  ${item.Show.Amount.toFixed(2)}
                </span>
              ) : (
                item.FinishPos === -1 && <span>-</span>
              )}
            </td>
          )}
        </tr>
      );
    });

  moneyBetHeaders = (
    <>
      <td></td>
      <td></td>
      <td className="moneyBetsHeader">Money</td>
      <td className="moneyBetsHeader"># Bets</td>
      <td className="moneyBetsHeader">Money</td>
      <td className="moneyBetsHeader"># Bets</td>
      <td className="moneyBetsHeader">Money</td>
      <td className="moneyBetsHeader"># Bets</td>
    </>
  );

  headers = (
    <>
      <tr className="text-center">
        <th
          style={{
            verticalAlign: "middle",
          }}
        >
          #
        </th>
        <th
          style={{
            verticalAlign: "middle",
          }}
        >
          Horse
        </th>
        <th
          colSpan={showBetsColumn ? 2 : 1}
          data-toggle="modal"
          data-target="#openBetsChartModal"
          className="wpsBets"
          onClick={() => getOpenBetsChartByWT(0)}
        >
          Win
        </th>
        <th
          colSpan={showBetsColumn ? 2 : 1}
          style={{
            verticalAlign: "middle",
          }}
          data-toggle="modal"
          data-target="#openBetsChartModal"
          className="wpsBets"
          onClick={() => getOpenBetsChartByWT(1)}
        >
          Place
        </th>
        <th
          colSpan={showBetsColumn ? 2 : 1}
          data-toggle="modal"
          data-target="#openBetsChartModal"
          className="wpsBets"
          onClick={() => getOpenBetsChartByWT(2)}
        >
          Show
        </th>
      </tr>
      {showBetsColumn && <tr>{moneyBetHeaders}</tr>}
    </>
  );

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idWin}
        displayInfoChart={displayInfoChart}
        nameWT="Win"
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <SwitchActiveBetsColum
        showBetsColumn={showBetsColumn}
        setShowBetsColumn={setShowBetsColumn}
      />
      <div
        className="tab-pane fade show active"
        id="Win"
        role="tabpanel"
        aria-labelledby="Win"
      >
        <table className="table table-striped table-sm">
          <thead>{headers}</thead>
          <tbody className="table-sm text-center table-bordered">
            {tableContent}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WinPlaceShow;
